import { jsx } from "react/jsx-runtime";
import { useState, useLayoutEffect } from "react";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { HANDLE_CLASS } from "./dialog.constants.js";
const DraggablePaperComponent = (props, dialogRef, initialPosition) => {
  const [position, setPosition] = useState(void 0);
  const handleDrag = (_e, { x, y }) => {
    setPosition({
      x,
      y
    });
  };
  useLayoutEffect(() => {
    setPosition(initialPosition);
  }, [initialPosition]);
  return /* @__PURE__ */ jsx(Draggable, { position, onDrag: handleDrag, handle: `.${HANDLE_CLASS}`, children: /* @__PURE__ */ jsx(Paper, { ref: dialogRef, ...props, style: { margin: 0, ...props.style } }) });
};
export {
  DraggablePaperComponent
};
